import { RestClient } from './RestClient'
import store from 'src/store'

export class CustomersClient extends RestClient {
  /**
   * CustomersClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/customers`
  }

  /**
   * Get a list of customers
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Show the specified customers
   *
   * @param {(...number|number[])} id - Customers to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Search for customers
   *
   * @param query
   * @returns {AxiosPromise}
   */
  search (query) {
    this.params.q = query

    return this.call('get', `${this.baseUrl}/search`)
  }

  /**
   * Exports customers
   *
   * @param id
   * Export specific customers as vcards
   *
   * @param {number|number[]} id
   *
   * @returns {AxiosPromise}
   */
  export (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`, {}, {
      'Accept': 'text/x-vcard'
    })
  }

  /**
   * Export all customers in the given format
   *
   * @param {string} format
   *
   * @returns {AxiosPromise}
   */
  exportAll (format) {
    return this.call('post', `${this.baseUrl}/export`, {
      format
    })
  }
}
